import { buildAppScheme } from '@/shared/lib'

/**
 * OneLink에 앱스킴 딥링크를 실어 반환한다. `af_dp`·`deep_link_value` 둘 다 동일한
 * 딥링크를 넣어 앱이 어느 값으로 라우팅해도 같은 화면으로 가도록 통일한다
 * (OneLink 기본 deep_link_value=`home`을 덮는다). 유효하지 않은 URL이면 원본 반환.
 * @param deeplink 완성된 앱스킴 딥링크 (예: `macarongapp:///modoo/...`, buildAppScheme 결과)
 */
export const withAppSchemeAfDp = (
  onelinkUrl: string,
  deeplink: string
): string => {
  try {
    const url = new URL(onelinkUrl)
    url.searchParams.set('af_dp', deeplink)
    url.searchParams.set('deep_link_value', deeplink)
    return url.toString()
  } catch {
    return onelinkUrl
  }
}

// 앱 webshow는 도메인 없는 "경로"만 받는다. 풀 URL을 넘기면 Android가 콜론을 '/'로
// 치환해 깨진다. webPagePath는 이미 인코딩된 pathname이라 추가 인코딩 없이 넣는다.
const MODOO_WEBSHOW_PATH = '/modoo/webshow'

/**
 * OneLink에 앱 웹뷰(모두의 차고) webshow 딥링크(`macarongapp[env]:///modoo/webshow{경로}`)를
 * 실어 반환한다. 앱스킴 prefix는 배포 환경(dev/stage/prod)에 맞춰 결정된다 (buildAppScheme).
 */
export const withWebshowAfDp = (
  onelinkUrl: string,
  webPagePath: string
): string =>
  withAppSchemeAfDp(
    onelinkUrl,
    buildAppScheme(`${MODOO_WEBSHOW_PATH}${webPagePath}`)
  )

// 앱 MODOO_WEB_URL(iOS)·modooUrl(AOS)이 이미 이 경로까지 포함한다(`도메인/v2/modoocar`).
// 앱은 webshow 뒤 경로를 이 base에 이어 붙이므로, 여기선 그 base를 뺀 나머지만 넘긴다.
const MODOO_WEB_BASE_PATH = '/v2/modoocar'

/** 앱 modoo base(`/v2/modoocar`) 이후의 경로 + 쿼리. 앱 웹뷰로 열 대상. */
export const getCurrentPagePath = (): string => {
  const { pathname, search } = window.location
  const relativePath = pathname.startsWith(MODOO_WEB_BASE_PATH)
    ? pathname.slice(MODOO_WEB_BASE_PATH.length)
    : pathname
  return `${relativePath}${search}`
}
